export default __webpack_public_path__ + "static/media/categoria_noi_asistente.25857365.svg";